import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { CurrentItemTitle } from '../../components/Ad/Sections/CurrentItemDesc/styled';

interface GetItemTitleProps {
  lease?: boolean | null;
  rooms?: number | null;
  category?: string | undefined;
  area?: string;
  areaCurrency?: string | null;
  location?: {
    __typename: 'Location';
    fullName?: string | null;
    path: string;
  } | null;
  isClearString?: boolean;
  simpleData?: boolean;
}

const StyledLink = styled(Link)`
  text-decoration: none;
  padding-bottom: 0.5px;
  border-bottom: 1px solid;
`;

export const getItemTitle = ({
  lease,
  rooms,
  category,
  area,
  areaCurrency,
  location,
  isClearString = false,
  simpleData = false
}: GetItemTitleProps) => {
  const { t } = useTranslation();

  const typeItem = lease
    ? t('pages.current_item.for_lease')
    : t('pages.current_item.for_sale');

  const roomsString = rooms
    ? t('cards.item_card.rooms', {
        count: rooms
      })
    : '';

  const areaString = area ? `${area} ${areaCurrency}` : '';

  const title = `${simpleData ? '' : typeItem} ${roomsString} ${
    category?.toLowerCase() ?? ''
  } ${areaString}${location?.fullName ? ', ' : ''}`;

  const locationString = location?.fullName ? location.fullName : '';
  const link = location?.path && (
    <StyledLink data-stat="location-district" href={location?.path}>
      {locationString}
    </StyledLink>
  );

  const clearString = `${title}${locationString}`;
  if (isClearString) return clearString;

  return (
    <CurrentItemTitle data-cy="cur-item-desc__title">
      {title}
      {link}
    </CurrentItemTitle>
  );
};
